import React, { useState, useEffect } from "react";
import "../styles/ContactForm.css";
import { submitContactForm } from "../services/ContactService";

interface ContactFormProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ContactForm = ({ isOpen, onClose }: ContactFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    if (!isOpen) {
      setShowSuccess(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setContactData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await submitContactForm(contactData);

      setContactData({
        name: "",
        email: "",
        message: "",
      });

      setShowSuccess(true);
    } catch (error) {
      alert("Failed to send message. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-overlay" onClick={onClose}>
      <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
        {showSuccess ? (
          <div className="success-view">
            <div className="success-header">
              <span className="success-subtitle">Message Sent</span>
            </div>

            <div className="success-content">
              <h3 className="success-heading">Thanks for reaching out!</h3>
              <p>
                We've received your message and will be in touch with you
                shortly.
              </p>
              <button
                type="button"
                className="contact-send-btn success-btn"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="contact-header">
              <h2 className="contact-title">Contact Us</h2>
              <p className="contact-subtitle">Reach out</p>
            </div>

            <form onSubmit={handleSubmit} className="contact-form-container">
              <div className="contact-field-group">
                <label htmlFor="contact-name">Name</label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  placeholder="Your Name"
                  value={contactData.name}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div className="contact-field-group">
                <label htmlFor="contact-email">Email</label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  placeholder="name@example.com"
                  value={contactData.email}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div className="contact-field-group">
                <label htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  placeholder="How can we help you?"
                  value={contactData.message}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div className="contact-actions">
                <button
                  type="button"
                  className="contact-cancel-btn"
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="contact-send-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
